<template lang="pug">
router-link.dashboard-shortcut(:style="{backgroundColor}" :to="to")
  .dashboard-icon
    slot(name="icon")
  h5.dashboard-heading {{ heading }}
</template>

<script>
export default {
  name: 'DashboardShortcut',
  props: {
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
    heading: {
      type: String,
      default: 'Dashboard Shortcut',
    },
    to: {
      type: [String, Object],
      default: '/',
    },
  },
  methods: {
    clicked() {
      this.$router.push(this.to)
    },
  },
  mounted() {
    scrollTo(0, 0)
  },
}
</script>

<style lang="scss" scoped>
.dashboard-shortcut {
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.3rem;
  color: white;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
  width: 350px;

  margin-right: 2rem;
}

.dashboard-icon {
  margin-top: auto;
  margin-bottom: auto;
}

.dashboard-heading {
  margin-top: 0.3rem;
}
</style>
